<template>
  <div>
    <div class="help">
      <div>
        <p><a :href="help_url" target="_blank">ヘルプを見る。</a></p>
      </div>
    </div>
    <graph-title @delivery="setTitle" :init_title="title"/>
    <draw-graph ref="drawGraph" :title="title" @setTitle="setTitle"/>
  </div>
</template>

<script>
import GraphTitle from "@/components/Title.vue";
import DrawGraph from "@/components/DrawGraph.vue";

export default {
  name: "create",
  components: {
    GraphTitle,
    DrawGraph
  },
  beforeRouteLeave (to, from, next) {
    const fullscreen_flg = this.$store.state.full_screen_flg;

    if (fullscreen_flg) {
      this.$store.commit('setFullScreenFlg', false);
      this.$refs.drawGraph.scrollLock(false);
      next();
    } else {
      next();
    }
  },
  data() {
    return {
      title: "",
      help_url: "https://note.mu/emoooo/n/n42daf1932788"
    }
  },
  methods: {
    setTitle(val) {
      this.title = val;
    }
  }
}
</script>
<style scoped lang="scss">
div.help {
  width: 100%;
  position: fixed;
  z-index: 1;
  div {
    background: #b4e37f;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    p {
        margin: 5px;
      a {
        color: #333333;
      }
    }
  }
}
</style>